import React from "react";
import BooksNavbar from "./BooksNavbar";
import BooksFooter from "./BooksFooter";

const BooksContact = () => {
  return (
    <div>
      {/* CONTACT PAGE */}
      <section className="relative min-h-screen bg-white overflow-hidden">
        <BooksNavbar textColor="black" />

        <div className="relative z-10 pt-32 pb-20">
          <div className="max-w-6xl mx-auto px-6 md:px-12">
            
            {/* Page heading */}
            <div className="text-center mb-14">
              <p
                className="text-xs tracking-[0.35em] text-[#8c8b5f] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Contact
              </p>

              <h1
                className="text-5xl md:text-7xl text-black leading-tight mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Get in touch.
              </h1>

              <div className="flex items-center w-full max-w-sm mx-auto mb-8">
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
                <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              </div>

              <p
                className="text-xl md:text-2xl italic text-[#5f6f4f] leading-relaxed max-w-3xl mx-auto"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                For media enquiries, general questions, and information about{" "}
                <em>Think Before You Think</em>.
              </p>
            </div>

            {/* Contact cards */}
            <div className="grid md:grid-cols-2 gap-8">
              
              {/* Media Enquiries */}
              <div className="bg-[#f5f3ef] p-8 md:p-10 shadow-sm">
                <p
                  className="text-xs tracking-[0.3em] text-[#D4AF37] mb-4 uppercase"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Media Enquiries
                </p>

                <h2
                  className="text-3xl text-black mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  For media-related inquiries
                </h2>

                <p
                  className="text-gray-700 leading-relaxed mb-2"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Please contact:
                </p>

                <p
                  className="text-gray-800 leading-relaxed mb-1"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  <strong>Jeff Renaud</strong>
                </p>

                <p
                  className="text-gray-700 leading-relaxed mb-1"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Media Relations Consultant
                </p>

                <p
                  className="text-gray-700 leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Western University
                </p>

                <a
                  href="tel:5195207281"
                  className="text-[#8c8b5f] font-semibold"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  519-520-7281
                </a>
              </div>

              {/* General Enquiries */}
              <div className="bg-[#f5f3ef] p-8 md:p-10 shadow-sm">
                <p
                  className="text-xs tracking-[0.3em] text-[#D4AF37] mb-4 uppercase"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  All Other Enquiries
                </p>

                <h2
                  className="text-3xl text-black mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  For general inquiries
                </h2>

                <p
                  className="text-gray-700 leading-relaxed mb-2"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Please contact:
                </p>

                <p
                  className="text-gray-800 leading-relaxed mb-1"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  <strong>The Owen Lab</strong>
                </p>

                <p
                  className="text-gray-700 leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Western University
                </p>

                <a
                  href="mailto:OwenLab@uwo.ca"
                  className="text-[#8c8b5f] font-semibold"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  OwenLab@uwo.ca
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <BooksFooter />
    </div>
  );
};

export default BooksContact;